import FnButton from '../../elements/FnButton/index';
import { SpanEndIcon } from '../../elements/FnButton/styles';
import styled from 'styled-components';
import { FnTagVariants } from './constants';
import { theme } from '../../../theme';

const { colors, filters } = theme;

const Base = styled(FnButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 15px;
  min-height: 27px;
  font-weight: normal;
  border: none;
  box-shadow: none;
  transition: background-color 0.3s ease;

  ${SpanEndIcon} {
    margin-left: 10px;
  }
`;

const ButtonDefaultTag = styled(Base)`
  color: ${colors.secondary};
  background-color: ${colors.surfaceFront};

  :hover:not([disabled]) {
    background-color: ${filters.lightGrayHover};
  }

  path {
    fill: ${colors.secondary};
  }
`;

const ButtonOutlineTag = styled(Base)`
  color: ${colors.secondary};
  background-color: ${colors.white};
  border: 1px solid ${colors.secondary};

  :hover {
    color: ${colors.white};
    background-color: ${colors.secondaryHover};
    border: 1px solid ${colors.secondaryHover};

    path {
      fill: ${colors.white};
    }
  }

  path {
    fill: ${colors.secondary};
  }
`;

export const TAGS: Record<FnTagVariants, typeof Base> = Object.freeze({
  [FnTagVariants.Default]: ButtonDefaultTag,
  [FnTagVariants.Outline]: ButtonOutlineTag
});
